import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import axios from "axios";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import DiagramEditor from "@/components/diagram/DiagramEditor.vue";
import { Events } from "@/events/events";
import { buildD2DiagramLabelsComment } from "@/util/d2Util";
let DiagramChapterEditor = class DiagramChapterEditor extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "chapterId", void 0);
    _defineProperty(this, "visionEnabled", void 0);
    _defineProperty(this, "isProcessing", false);
    _defineProperty(this, "diagramSaved", false);
    _defineProperty(this, "diagramData", null);
  }
  mounted() {
    this.getDiagramEditorData();
  }
  getDiagramEditorData() {
    this.isProcessing = true;
    axios.get(`/api/v2/chapter/${this.chapterId}/diagram-for-editing`).then(({
      data
    }) => {
      this.diagramData = data;
    }).catch(() => WElMessage.showErrorMessage(this.$t('errors.default'))).finally(() => {
      this.isProcessing = false;
    });
  }
  async saveDiagramData(d2Code, compiledDiagram, diagramSVG) {
    const commentBlock = buildD2DiagramLabelsComment(compiledDiagram);
    const d2CodeWithComment = commentBlock ? `${d2Code}${commentBlock}` : d2Code;
    if (!d2Code?.length || d2Code === this.diagramData?.d2Code) {
      return;
    }
    const formData = new FormData();
    formData.append('d2Code', d2CodeWithComment);
    this.isProcessing = true;
    axios.put(`/api/v2/chapter/${this.chapterId}/diagram`, formData).then(response => {
      WElMessage.showSuccessMessage(this.$t('diagramEditor.onSaveSuccess'));
      trig(Events.RAFRAICHIR_PLAN_CHAPITRE, this.chapterId);
      this.diagramData = response.data;
      this.diagramSaved = true;
    }).catch(() => {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    }).finally(() => {
      this.isProcessing = false;
    });
  }
  restart() {
    this.isProcessing = true;
    axios.delete(`/api/v2/chapter/${this.chapterId}/diagram`).then(() => {
      this.diagramData = null;
      this.diagramSaved = false;
      trig(Events.RAFRAICHIR_PLAN_CHAPITRE, this.chapterId);
    }).catch(() => WElMessage.showErrorMessage(this.$t('errors.default'))).finally(() => {
      this.isProcessing = false;
    });
  }
};
__decorate([Prop({
  required: true
})], DiagramChapterEditor.prototype, "chapterId", void 0);
__decorate([Prop({
  default: false
})], DiagramChapterEditor.prototype, "visionEnabled", void 0);
DiagramChapterEditor = __decorate([Component({
  components: {
    DiagramEditor
  }
})], DiagramChapterEditor);
export default DiagramChapterEditor;